export const iconFontAwesomeReligionStarOfDavid = (
	<i className="fa-solid fa-star-of-david"></i>
);
